<template>
    <div>
        <ul class="spots-list p-0 d-flex mt-2 w-100">
            <li
                v-for="(spot,index) in spots"
                :key="`${spotType}-${index}`"
                :data-selected="selectedSpot && selectedSpot.index === index"
                :data-busy="spot.busy"
                @click="handleClick(index, spot.busy)"
                class="spots-item c16 p1n text-center">
                <p
                    v-b-tooltip.hover
                    :title="spot.busy ? (spotType === 'owner-spot' ? 'Spot is taken': 'Busy spot') : 'Claim this spot'">
                    {{spot.number}}
                </p>
            </li>
        </ul>
    </div>
</template>


<script>
export default {
    name: 'SpotsList',
    props: {
        spots: Array,
        selectedSpot: Object,
        spotType: String
    },
    methods: {
        handleClick(index, spotState){
            this.$emit('selectSpot', index, spotState)
        }
    }
}
</script>

<style lang="scss">
    ul.spots-list {
        li.spots-item {
            width: 29px;
            height: 29px;
            line-height: 29px;
            background: #ffffff;
            border: 1px solid #0ACF97;
            border-radius: 50%;
            cursor: pointer;
            margin-right: 11px;
            color: #0ACF97 !important;
            transition: all 0.2s ease;

            &[data-busy] {
                background-color: #B8CDD7 !important;
                color: #ffffff !important;
                border: 0;

                &:hover {
                    cursor: default;
                }
            }

            &[data-selected] {
                background-color: #0ACF97 !important;
                border: 0;
                color: #ffffff !important;
                cursor: default;
            }

            &:hover {
                background: #0ACF97;
                color: #ffffff !important;
            }
        }
    }
</style>











